import { useMaskPII } from 'hooks/useMaskPII';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';

export const testId = 'changePostcodeTestId';

type ChangePostcodeProps = {
  postcode?: string;
  handleGoBack?: () => void;
  ctaLabel?: string;
};

export const ChangePostcode = ({
  postcode,
  handleGoBack,
  ctaLabel = 'Change'
}: ChangePostcodeProps) => {
  const { mask } = useMaskPII();

  return (
    <span data-testid={testId}>
      <span {...mask}>{postcode}</span>
      <br />
      <NsSecondaryCta onClick={handleGoBack}>{ctaLabel}</NsSecondaryCta>
    </span>
  );
};
